"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
function getJapaneseLocalizedName(userInfo) {
    var SAN = 'さん';
    var SAMA = '様';
    var informalName = ("" + userInfo.familyName + SAN).trim();
    var formalName = ("" + userInfo.familyName + userInfo.givenName + SAMA).trim();
    var formalNameAbbreviated = ("" + userInfo.familyName + SAMA).trim();
    return {
        informalName: informalName,
        formalName: formalName,
        formalNameAbbreviated: formalNameAbbreviated,
    };
}
function getDefaultLocalizedName(userInfo) {
    var informalName = userInfo.givenName;
    var formalName = (userInfo.givenName + " " + userInfo.familyName).trim();
    var formalNameAbbreviated = (userInfo.givenName + " " + (userInfo.familyName.length > 0 ? userInfo.familyName[0] : '')).trim();
    return {
        informalName: informalName,
        formalName: formalName,
        formalNameAbbreviated: formalNameAbbreviated,
    };
}
function getLocalizedNames(userInfo, userLocale) {
    switch (userLocale) {
        case types_1.SupportedLanguages.JA_JP:
        case types_1.SupportedLanguages.JA: {
            return getJapaneseLocalizedName({
                givenName: userInfo.givenName.trim(),
                familyName: userInfo.familyName.trim(),
            });
        }
        default: {
            return getDefaultLocalizedName({
                givenName: userInfo.givenName.trim(),
                familyName: userInfo.familyName.trim(),
            });
        }
    }
}
exports.getLocalizedNames = getLocalizedNames;
